import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Linkedin, Github } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-border/40 bg-background/95">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to="/" className="flex items-center font-medium -ml-2">
              <img
                src="/future lens pro logo.png"
                alt="FutureLens Pro"
                className="h-28 md:h-44 w-auto"
              />
            </Link>
            <p className="text-sm text-muted-foreground">
              Your personal board of AI-powered career advisors. Expert guidance equal to a $50,000 consulting engagement.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-muted-foreground hover:text-primary" aria-label="Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-primary" aria-label="GitHub">
                <Github className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/#pricing" className="text-muted-foreground hover:text-foreground">Subscription Plans</a>
              </li>
              <li>
                <Link to="/user-guide" className="text-muted-foreground hover:text-foreground">User Guide</Link>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground">Testimonials</a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground">FAQ</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-foreground">About</Link>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-foreground">Blog</a>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-foreground">Contact</Link>
              </li>
              <li>
                <Link to="/affiliates" className="text-muted-foreground hover:text-foreground">Affiliates</Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-muted-foreground hover:text-foreground">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-muted-foreground hover:text-foreground">Terms of Service</Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-muted-foreground hover:text-foreground">Cookie Policy</Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-border/40 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center mb-4">
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} Future Lens Pro, Optivus Business Solutions LLC. All Rights Reserved
            </p>
            <p className="text-xs text-muted-foreground mt-4 md:mt-0">
              Empowering career transformations worldwide
            </p>
          </div>
          <div className="text-xs text-muted-foreground text-center md:text-left max-w-4xl">
            <p className="mb-2">
              <strong>Disclaimer:</strong> FutureLens provides career intelligence and guidance for informational purposes. Results and outcomes vary based on individual circumstances, market conditions, and effort. Career advancement depends on numerous factors beyond AI analysis. FutureLens does not guarantee specific employment outcomes, salary increases, or career transitions.
            </p>
            <p>
              <strong>Support:</strong> For assistance, contact connect@optivusbusinesssolutions.com
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;